<div class="">
  <form class="address-form" [formGroup]="addressForm" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="form-group">
        <label for="locationName">Location / Branch Name<span class="required">*</span></label>
        <input
          id="locationName"
          type="text"
          formControlName="branch"
          class="form-control"
          maxlength="100"
        />
        <div class="invalid-feedback" *ngIf="branch?.invalid && branch?.dirty">
          <div *ngIf="branch?.errors?.['required']">Location Name is required</div>
          <div *ngIf="branch?.errors?.['standardName']">
            {{ branch?.errors?.['standardName']?.message }}
          </div>
          <div *ngIf="branch?.errors?.['maxlength']">
            Location Name cannot exceed 100 characters
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="streetAddress">Street Address<span class="required">*</span></label>
        <input
          id="streetAddress"
          type="text"
          formControlName="street_address"
          class="form-control"
          [class.is-invalid]="street_address?.invalid && street_address?.dirty"
          maxlength="200"
        />
        <div class="invalid-feedback" *ngIf="street_address?.invalid && street_address?.dirty">
          <div *ngIf="street_address?.errors?.['required']">Street Address is required</div>
          <div *ngIf="street_address?.errors?.['standardName']">
            {{ street_address?.errors?.['standardName']?.message }}
          </div>
          <div *ngIf="street_address?.errors?.['maxlength']">
            Street Address cannot exceed 200 characters
          </div>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label for="city">City<span class="required">*</span></label>
        <input
          id="city"
          type="text"
          formControlName="city"
          class="form-control"
          [class.is-invalid]="city?.invalid && city?.dirty"
          maxlength="100"
        />
        <div class="invalid-feedback" *ngIf="city?.invalid && city?.dirty">
          <div *ngIf="city?.errors?.['required']">City is required</div>
          <div *ngIf="city?.errors?.['cityState']">{{ city?.errors?.['cityState']?.message }}</div>
          <div *ngIf="city?.errors?.['maxlength']">City cannot exceed 100 characters</div>
        </div>
      </div>

      <div class="form-group">
        <label for="state">State<span class="required">*</span></label>
        <div class="select-wrapper p-custom-select">
          <mat-select
            id="state"
            class="form-select"
            formControlName="state"
            placeholder="Select State"
            disableOptionCentering
            [class.is-invalid]="state?.invalid && state?.dirty"
          >
            <app-select-search #statesSearch placeholder="Search"></app-select-search>
            <mat-option
              *ngFor="let state of states | selectFilter: statesSearch.query : ['name']"
              [value]="state.name"
              >{{ state.name }}</mat-option
            >
          </mat-select>
        </div>
        <div class="invalid-feedback" *ngIf="state?.invalid && state?.dirty">
          <div *ngIf="state?.errors?.['required']">State is required</div>
          <div *ngIf="state?.errors?.['cityState']">
            {{ state?.errors?.['cityState']?.message }}
          </div>
          <div *ngIf="state?.errors?.['maxlength']">State cannot exceed 50 characters</div>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group country-select">
        <label for="country">Country<span class="required">*</span></label>
        <div class="select-wrapper p-custom-select" style="pointer-events: none">
          <mat-select
            id="country"
            formControlName="country"
            placeholder="Select a country"
            class="form-select"
            [class.is-invalid]="country?.invalid && country?.dirty"
          >
            <!-- No search field: the wrapper sets pointer-events: none, so this
                 select is read-only and the panel cannot be interacted with. -->
            <mat-option *ngFor="let countrie of countries" [value]="countrie.name">{{
              countrie.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="invalid-feedback" *ngIf="country?.invalid && country?.dirty">
          <div *ngIf="country?.errors?.['required']">Country is required</div>
        </div>
      </div>

      <div class="form-group">
        <label for="zip">ZIP Code<span class="required">*</span></label>
        <input
          id="zip"
          type="text"
          formControlName="zip_code"
          class="form-control"
          [class.is-invalid]="zip_code?.invalid && zip_code?.dirty"
          maxlength="10"
        />
        <div class="invalid-feedback" *ngIf="zip_code?.invalid && zip_code?.dirty">
          <div *ngIf="zip_code?.errors?.['required']">ZIP Code is required</div>
          <div *ngIf="zip_code?.errors?.['usaZipCode']">
            {{ zip_code?.errors?.['usaZipCode']?.message }}
          </div>
          <div *ngIf="zip_code?.errors?.['maxlength']">ZIP Code cannot exceed 10 characters</div>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label for="timezone">Time Zone<span class="required">*</span></label>
        <div class="select-wrapper p-custom-select">
          <mat-select
            id="timezone"
            class="form-select"
            formControlName="timezone"
            placeholder="Select time zone"
            disableOptionCentering
            [class.is-invalid]="timezone?.invalid && timezone?.dirty"
          >
            <app-select-search #timezonesSearch placeholder="Search"></app-select-search>
            <mat-option
              *ngFor="
                let timezone of timezones
                  | selectFilter: timezonesSearch.query : ['shortLabel', 'value']
              "
              [value]="timezone.value"
              >{{ timezone.shortLabel }}</mat-option
            >
          </mat-select>
        </div>
        <div class="invalid-feedback" *ngIf="timezone?.invalid && timezone?.dirty">
          <div *ngIf="timezone?.errors?.['required']">Time Zone is required</div>
        </div>
      </div>
      <div class="form-group form-group--spacer" aria-hidden="true"></div>
    </div>

    <div class="form-actions">
      <button
        type="submit"
        class="btn btn-primary btn-medium"
        [ngClass]="{ disabled: addressForm.invalid || !isFormModified || isSubmitting }"
        [disabled]="addressForm.invalid || !isFormModified || isSubmitting"
      >
        <span *ngIf="!isSubmitting">Save</span>
        <span *ngIf="isSubmitting" class="saving-content">
          <div class="spinner-small"></div>
          Saving...
        </span>
      </button>
    </div>
  </form>
</div>
